import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api.service';
import SITE_CONFIG from '../config/site.config';
import './Legal.css';

const EXHIBITOR_TERMS = [
  'Application form must be completely filled with correct GST number.',
  'For one stall only 3 persons including one exhibitor and two sub-exhibitors are allowed.',
  'For one stall, a single room for accommodation will be provided; extra rooms will be charged as per tariff.',
  'Meal coupons will be provided as per booked stall (for one stall, only three persons\' meal coupons are allowed).',
  'For the Patna exhibition there will be two types of entry for visitors: first half (10:00 AM to 4:00 PM) from the main entry, and second half (4:00 PM to 7:00 PM) from the first floor, with alternate entry on the next day.',
  'Stall booking amount will not be refunded under any circumstances.',
  'All dues must be cleared before the first day of the exhibition.',
  'Exhibitors should receive their welcome kit including all details before the exhibition day.',
  'Exhibitors must collect their bill for the exhibition before completion of the event; requests after completion will not be entertained.',
  'In any unforeseen circumstances, if an event is called off, stall bookings may be transferred to the next scheduled exhibition. Refunds will not be provided in such cases.',
  'Exhibitors who wish to fabricate or decorate their stall must use vendors authorized by SSVASS only.',
];

const DEFAULT_VISITOR_TERMS = [
  'एक रजिस्ट्रेशन सिर्फ़ एक व्यक्ति कि लिए मान्य है।',
  'रजिस्ट्रेशन करने के समय कृपया दिये गये जानकारी की जाँच अवश्य कर लें अन्यथा ग़लत जानकारी पर प्रवेश वर्जित है।',
  'अपना पहचान पत्र संख्या अवश्य मिला लें।',
  'प्रदर्शनी में तीन हॉल हैं और आपको तीनों हॉल में घूमना अनिवार्य है।',
  '18 वर्ष से कम उम्र के व्यक्तियों के लिए प्रवेश नहीं है।',
  'यह प्रदर्शनी सिर्फ़ आभूषण व्यापारियों के लिए है।',
  'प्रदर्शनी में किसी भी प्रकार की अस्त्र-सस्त्र और अग्निसमक पदार्थ पूर्णयतः वर्जित है।',
  'तम्बाकू, गुटका एवं नशीले पदार्थों का सेवन पूर्णयतः वर्जित है।',
  'कृपया अपना साफ़ फ़ोटो एवं आधार कार्ड अपलोड करें।',
  'सुरक्षा वजहों से सबको जाँच अनिवार्य है, आपका सहयोग अपेक्षित है।',
  'प्रदर्शनी में आने के लिए अपने साथ अपना पहचानपत्र एवं अपने दुकान का विज़िटिंग कार्ड या जीएसटी सर्टिफिकेट अवश्य लायें।',
  'किसी भी सहायता के लिए संपर्क करें - 0612-2675064',
];

const parseTermsResponse = (response) => {
  if (Array.isArray(response.data)) {
    return response.data;
  }
  if (response.data?.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  if (response.data?.terms && Array.isArray(response.data.terms)) {
    return response.data.terms;
  }
  return [];
};

const Terms = () => {
  const [visitorTerms, setVisitorTerms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await apiService.getTerms();
        const termsArray = parseTermsResponse(response);
        setVisitorTerms(termsArray.length > 0 ? termsArray : DEFAULT_VISITOR_TERMS);
      } catch {
        setVisitorTerms(DEFAULT_VISITOR_TERMS);
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Terms &amp; Conditions</h2>
            </div>
            <div className="col-12">
              <Link to="/">Home</Link>
              <Link to="/terms">Terms &amp; Conditions</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="about legal-page">
        <div className="container">
          <div className="section-header">
            <p>Legal</p>
            <h2>Terms &amp; Conditions</h2>
          </div>

          <div className="legal-content">
            <h3>Exhibition &amp; Stall Booking Terms</h3>
            <p>
              The following terms apply to exhibitors and stall bookings at {SITE_CONFIG.name}{' '}
              {SITE_CONFIG.title}.
            </p>
            <ol>
              {EXHIBITOR_TERMS.map((term, index) => (
                <li key={index}>{term}</li>
              ))}
            </ol>

            <h3>Visitor Registration Terms (नियम और शर्तें)</h3>
            <p>The following terms apply to visitors registering for the exhibition:</p>
            {loading ? (
              <p className="legal-loading">Loading terms...</p>
            ) : (
              <ol>
                {visitorTerms.map((term, index) => (
                  <li key={index}>{term}</li>
                ))}
              </ol>
            )}

            <p>
              For questions regarding these terms, please{' '}
              <Link to="/contact">contact us</Link> or email{' '}
              <a href={`mailto:${SITE_CONFIG.email}`}>{SITE_CONFIG.email}</a>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
